import Main from '../pages/Main.vue';
import PageName from '../constant/PageName';
import PermissionIds from '../constant/PermissionIds';
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: '/system',
    icon: 'network',
    name: 'system',
    title: '主界面',
    component: Main,
    children: [
      {
        path:'declare_process',
        title: '首页',
        name: PageName.PAGE_DECLARE_PROCESS,
        icon: require('../assets/images/icon-shenbao.png'),
        component: function(resolve) { require(['../pages/declare_process/DeclareProcess.vue'], resolve) },
      },
      {
        path: 'my_info',
        title: '我的信息',
        name: PageName.PAGE_MY_INFO,
        icon: require('../assets/images/icon-xinxi.png'),
        component: function(resolve) { require(['../pages/my_info/MyInfo.vue'], resolve) },
      },
      {
        path: 'expert_application',
        title: '专家申请',
        name: PageName.PAGE_EXPERT_APPLICATION,
        icon: require('../assets/images/icon-shenqing.png'),
        component: function(resolve) { require(['../pages/expert_application/ExpertApplication.vue'], resolve) },
        children:[
          {
            path: 'my_application',
            title: '我的申请',
            name: PageName.PAGE_MY_APPLICATION,
            icon: require('../assets/images/icon-shenqing.png'),
            component: function(resolve) { require(['../pages/expert_application/view/MyApplicationView.vue'], resolve) },
          }
        ]
      },
      {
        path: 'my_task',
        title: '我的任务',
        name: PageName.PAGE_MY_TASK,
        icon: require('../assets/images/icon-renwu.png'),
        component: function(resolve) { require(['../pages/my_task/MyTask.vue'], resolve) },
        children:[
          {
           path: 'pending_task',
           title: '待接受任务',
           name: PageName.PAGE_PENDING_TASK,
           // icon: require('../assets/images/icon-baoming.png'),
           component: function(resolve) { require(['../pages/my_task/view/PendingTaskView.vue'], resolve) },
          },
          {
           path: 'processed_task',
           title: '需处理任务',
           name: PageName.PAGE_PROCESSED_TASK,
           // icon: require('../assets/images/icon-baoming.png'),
           component: function(resolve) { require(['../pages/my_task/view/ProcessedTaskView.vue'], resolve) },
          },
         ]
      },
      {
        path: 'activity_registration',
        title: '活动报名',
        name: PageName.PAGE_ACTIVITY_REGISTRATION,
        icon: require('../assets/images/icon-baoming.png'),
        component: function(resolve) { require(['../pages/activity_registration/ActivityRegistration.vue'], resolve) },
        children:[
         {
          path: 'active_list',
          title: '待处理活动',
          name: PageName.PAGE_ACTIVITY_LIST,
          // icon: require('../assets/images/icon-baoming.png'),
          component: function(resolve) { require(['../pages/activity_registration/view/ActivityListView.vue'], resolve) },
         },
         {
          path: 'active_enrolment',
          title: '已处理活动',
          name: PageName.PAGE_ACTIVITY_ENROLMENT,
          // icon: require('../assets/images/icon-baoming.png'),
          component: function(resolve) { require(['../pages/activity_registration/view/SignUpListView.vue'], resolve) },
         },
        ]
      },
      {
        path: '/message_list',
        title: '消息列表',
        name:'message_list',
        icon: require('../assets/images/icon-baoming.png'),
        // component:"message_list",
        component: function(resolve) { require(['../pages/message_list/message_list.vue'], resolve) },
        children:[
          {
            path: 'look_message',
            title: '查看消息',
            name: PageName.PAGE_LOOK_MESSAGE,
            icon: require('../assets/images/icon-baoming.png'),
            component: function(resolve) { require(['../pages/message_list/look_message.vue'], resolve) },
          },
          {
            path: 'feedback_appeal',
            title: '反馈诉求',
            name: PageName.PAGE_FEEDBACK_APPEAL,
            icon: require('../assets/images/icon-baoming.png'),
            component: function(resolve) { require(['../pages/message_list/feedback_appeal.vue'], resolve) },
          },
        ]
      },
    ]
  },
];

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  title: '首页',
  redirect: '/home',
  component: Main,
  children: [
    { path: 'home', title: '首页', name: PageName.PAGE_HOME_INDEX, component: function(resolve) { require(['../pages/Home.vue'], resolve) } },
  ]
};

export const loginRouter = {
  path: '/login',
  name: PageName.PAGE_LOGIN,
  meta: {
    title: '登录'
  },
  component: function(resolve) { require(['../pages/login/Login.vue'], resolve) }
};
export const registerRouter = {
  path: '/register',
  name: PageName.PAGE_REGISTER,
  meta: {
    title: '注册账号'
  },
  component: function(resolve) { require(['../pages/login/Register.vue'], resolve) }
};

export const forgetPasswordRouter = {
  path: '/forget_password',
  name: PageName.PAGE_FORGET_PASSWORD,
  meta: {
    title: '忘记密码'
  },
  component: function(resolve) { require(['../pages/login/ForgetPassword.vue'], resolve) }
};

export const page404 = {
  path: '/*',
  name: 'error-404',
  meta: {
    title: '404-页面不存在'
  },
  component: function(resolve) { require(['../pages/error_page/404.vue'], resolve) }
};

export const page403 = {
  path: '/403',
  meta: {
    title: '403-权限不足'
  },
  name: 'error-403',
  component: function(resolve) { require(['../pages/error_page/403.vue'], resolve) }
};

export const page500 = {
  path: '/500',
  meta: {
    title: '500-服务端错误'
  },
  name: 'error-500',
  component: function(resolve) { require(['../pages/error_page/500.vue'], resolve) }
};

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
  ...appRouter,
  otherRouter,
  loginRouter,
  registerRouter,
  forgetPasswordRouter,
  page500,
  page403,
  page404,
];



// WEBPACK FOOTER //
// ./src/router/router.js